import TableFilterSelect from '@aibees/elephant/components/table-filter-select/table-filter-select';
import { useAddEnrichmentTypeMetadata } from '@aibees/elephant/hooks/enrichment/use-add-enrichment-type-metadata';
import { EnrichmentTypeEnum } from '@aibees/elephant/types';
import { AdvanceTableFilterParams } from '@aibees/shared/features';
import { Stack } from '@mui/material';
import { memo } from 'react';
import { CONFIG } from './config';

type Props = AdvanceTableFilterParams;

export const EnrichmentTypeFilter = memo(({ filters, setFilter }: Props) => {
  const configWithMetadata = useAddEnrichmentTypeMetadata(CONFIG);

  return (
    <Stack flex={0.5}>
      <TableFilterSelect<EnrichmentTypeEnum>
        filters={filters}
        setFilter={setFilter}
        name="type"
        defaultValue={EnrichmentTypeEnum.ALL}
        options={configWithMetadata}
      />
    </Stack>
  );
});

EnrichmentTypeFilter.displayName = 'EnrichmentTypeFilter';
